import React from 'react';
import AclContext from "../components/Acl/AclContext";
var useAcl = function useAcl(sujet, action) {
  var acl = React.useContext(AclContext);
  return acl.isAllow(sujet, action);
};
export default useAcl;